import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=245d74d2&scoped=true&"
import script from "./Separator.vue?vue&type=script&lang=ts&"
export * from "./Separator.vue?vue&type=script&lang=ts&"
import style0 from "./Separator.vue?vue&type=style&index=0&id=245d74d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245d74d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
